import { SVGProps } from 'react';

const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={64}
    height={64}
    viewBox="0 0 64 64"
    fill="none"
    {...props}
  >
    <path
      fill="#19AC51"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M32 0C49.6 0 64 14.4 64 32C64 49.6 49.6 64 32 64C14.4 64 0 49.6 0 32
      C2.6011e-07 14.4 14.4 2.60095e-07 32 0ZM45.7188 21.7373C44.4691 20.4877 42.443
      20.4877 41.1934 21.7373L29.0557 33.875L23.3184 28.1377C22.0687 26.888 20.0426
      26.888 18.793 28.1377C17.5436 29.3874 17.5434 31.4135 18.793 32.6631L28.3486
      42.2188C28.7391 42.609 29.3722 42.6089 29.7627 42.2188L45.7188 26.2627C46.9683
      25.013 46.9683 22.987 45.7188 21.7373Z"
    />
  </svg>
);
export default SvgComponent;
